import { html, TemplateResult } from 'lit';
import { monthAndYearForPropertyDataRequest, PropertyDataUpdateLatch } from '../../../api/get-calendar-data-for-house';
import { formatCalendarDate } from '../../../helpers/date';
import { Dispatcher } from '../../../types/booking-request';

export function calendarControls(
	houseId: number,
	focusDate: Date,
	dispatch: Dispatcher,
	propertyDataUpdateLatch: PropertyDataUpdateLatch
): TemplateResult {
	const clickPreviousYearHandler = () => {
		const d = new Date( focusDate );
		d.setUTCFullYear( d.getUTCFullYear() - 1 );

		const monthAndYear = monthAndYearForPropertyDataRequest( d );
		propertyDataUpdateLatch.setInput( houseId, monthAndYear.year, monthAndYear.month );

		dispatch( {
			type: 'UPDATE_FOCUS_DATE',
			focusDate: d,
		} );
	};

	const clickPreviousMonthHandler = () => {
		const d = new Date( focusDate );
		if ( 0 === d.getUTCMonth() ) {
			d.setUTCFullYear( d.getUTCFullYear() - 1 );
			d.setUTCMonth( 11 );
		} else {
			d.setUTCMonth( d.getUTCMonth() - 1 );
		}

		const monthAndYear = monthAndYearForPropertyDataRequest( d );
		propertyDataUpdateLatch.setInput( houseId, monthAndYear.year, monthAndYear.month );

		dispatch( {
			type: 'UPDATE_FOCUS_DATE',
			focusDate: d,
		} );
	};

	const clickNextMonthHandler = () => {
		const d = new Date( focusDate );
		if ( 11 === d.getUTCMonth() ) {
			d.setUTCFullYear( d.getUTCFullYear() + 1 );
			d.setUTCMonth( 0 );
		} else {
			d.setUTCMonth( d.getUTCMonth() + 1 );
		}

		const monthAndYear = monthAndYearForPropertyDataRequest( d );
		propertyDataUpdateLatch.setInput( houseId, monthAndYear.year, monthAndYear.month );

		dispatch( {
			type: 'UPDATE_FOCUS_DATE',
			focusDate: d,
		} );
	};

	const clickNextYearHandler = () => {
		const d = new Date( focusDate );
		d.setUTCFullYear( d.getUTCFullYear() + 1 );

		const monthAndYear = monthAndYearForPropertyDataRequest( d );
		propertyDataUpdateLatch.setInput( houseId, monthAndYear.year, monthAndYear.month );

		dispatch( {
			type: 'UPDATE_FOCUS_DATE',
			focusDate: d,
		} );
	};

	return html`
		<button
			@click=${clickPreviousYearHandler}
			class="calendar__arrow calendar__arrow--previous-year"
		>
			<svg
				class="calendar__arrow__icon"
				viewBox="0 0 684 512"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path class="calendar__arrow__hover-element" d="M256.33,0a69.51,69.51,0,0,0-49.5,20.51l-186,186a70.07,70.07,0,0,0,0,99l186,186a70,70,0,0,0,99,0l35.32-35.32a70.08,70.08,0,0,0,0-99L240,256,341.16,154.84a70.08,70.08,0,0,0,0-99L305.84,20.51A69.55,69.55,0,0,0,256.33,0Z"/>
				<path class="calendar__arrow__hover-element" d="M578.86,0a69.55,69.55,0,0,0-49.51,20.51l-186,186a70.07,70.07,0,0,0,0,99l186,186a70,70,0,0,0,99,0l35.33-35.32a70.1,70.1,0,0,0,0-99L562.53,256,663.69,154.84a70.1,70.1,0,0,0,0-99L628.36,20.51A69.51,69.51,0,0,0,578.86,0Z"/>
				<path fill="currentColor" d="M256.33,38A31.9,31.9,0,0,1,279,47.37L314.3,82.7a32,32,0,0,1,0,45.27L208.91,233.36a32,32,0,0,0,0,45.28L314.3,384a32,32,0,0,1,0,45.27L279,464.63a32,32,0,0,1-45.27,0l-186-186a32,32,0,0,1,0-45.28l186-186A31.9,31.9,0,0,1,256.33,38m0-38a69.51,69.51,0,0,0-49.5,20.51l-186,186a70.07,70.07,0,0,0,0,99l186,186a70,70,0,0,0,99,0l35.32-35.32a70.08,70.08,0,0,0,0-99L240,256,341.16,154.84a70.08,70.08,0,0,0,0-99L305.84,20.51A69.55,69.55,0,0,0,256.33,0Z"/>
				<path fill="currentColor" d="M578.86,38a31.9,31.9,0,0,1,22.63,9.37L636.82,82.7a32,32,0,0,1,0,45.27L531.43,233.36a32,32,0,0,0,0,45.28L636.82,384a32,32,0,0,1,0,45.27l-35.33,35.33a32,32,0,0,1-45.27,0l-186-186a32,32,0,0,1,0-45.28l186-186A31.9,31.9,0,0,1,578.86,38m0-38a69.55,69.55,0,0,0-49.51,20.51l-186,186a70.07,70.07,0,0,0,0,99l186,186a70,70,0,0,0,99,0l35.33-35.32a70.1,70.1,0,0,0,0-99L562.53,256,663.69,154.84a70.1,70.1,0,0,0,0-99L628.36,20.51A69.51,69.51,0,0,0,578.86,0Z"/>
			</svg>
		</button>

		<button
			@click=${clickPreviousMonthHandler}
			class="calendar__arrow calendar__arrow--previous-month"
		>
			<svg
				class="calendar__arrow__icon"
				viewBox="0 0 14 20"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path class="calendar__arrow__hover-element" d="M9,18.1c0.2,0.2,0.6,0.4,0.9,0.4c0.3,0,0.6-0.1,0.9-0.4l1.4-1.4c0.5-0.5,0.5-1.3,0-1.8L8,10.9c-0.5-0.5-0.5-1.3,0-1.8 L12.2,5c0.5-0.5,0.5-1.3,0-1.8l-1.4-1.3c-0.5-0.5-1.3-0.5-1.8,0L1.8,9.1c-0.5,0.5-0.5,1.3,0,1.8L9,18.1z"/>
				<path fill="currentColor" d="M13.2,13.9L9.3,10l3.9-3.9c1.1-1.1,1.1-2.8,0-3.8l-1.4-1.4C10.8-0.2,9-0.2,8,0.9L0.8,8.1c-1.1,1.1-1.1,2.8,0,3.8L8,19.1 c1.1,1.1,2.8,1.1,3.8,0l1.4-1.4c1.1-1,1.2-2.7,0.1-3.8C13.3,13.9,13.3,13.9,13.2,13.9z M12.2,16.7l-1.4,1.4 c-0.2,0.2-0.6,0.4-0.9,0.4c-0.3,0-0.6-0.1-0.9-0.4l-7.2-7.2c-0.5-0.5-0.5-1.3,0-1.8L9,1.9c0.5-0.5,1.3-0.5,1.8,0l1.4,1.4 c0.5,0.5,0.5,1.3,0,1.8L8,9.1c-0.5,0.5-0.5,1.3,0,1.8l4.1,4.1C12.6,15.5,12.6,16.2,12.2,16.7L12.2,16.7z"/>
			</svg>
		</button>

		<span class="calendar__month-label">
			${formatCalendarDate( focusDate )}
		</span>

		<button
			@click=${clickNextMonthHandler}
			class="calendar__arrow calendar__arrow--next-month"
		>
			<svg
				aria-hidden="true"
				class="calendar__arrow__icon"
				viewBox="0 0 14 20"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path class="calendar__arrow__hover-element" d="M9,18.1c0.2,0.2,0.6,0.4,0.9,0.4c0.3,0,0.6-0.1,0.9-0.4l1.4-1.4c0.5-0.5,0.5-1.3,0-1.8L8,10.9c-0.5-0.5-0.5-1.3,0-1.8 L12.2,5c0.5-0.5,0.5-1.3,0-1.8l-1.4-1.3c-0.5-0.5-1.3-0.5-1.8,0L1.8,9.1c-0.5,0.5-0.5,1.3,0,1.8L9,18.1z"/>
				<path fill="currentColor" d="M13.2,13.9L9.3,10l3.9-3.9c1.1-1.1,1.1-2.8,0-3.8l-1.4-1.4C10.8-0.2,9-0.2,8,0.9L0.8,8.1c-1.1,1.1-1.1,2.8,0,3.8L8,19.1 c1.1,1.1,2.8,1.1,3.8,0l1.4-1.4c1.1-1,1.2-2.7,0.1-3.8C13.3,13.9,13.3,13.9,13.2,13.9z M12.2,16.7l-1.4,1.4 c-0.2,0.2-0.6,0.4-0.9,0.4c-0.3,0-0.6-0.1-0.9-0.4l-7.2-7.2c-0.5-0.5-0.5-1.3,0-1.8L9,1.9c0.5-0.5,1.3-0.5,1.8,0l1.4,1.4 c0.5,0.5,0.5,1.3,0,1.8L8,9.1c-0.5,0.5-0.5,1.3,0,1.8l4.1,4.1C12.6,15.5,12.6,16.2,12.2,16.7L12.2,16.7z"/>
			</svg>
		</button>

		<button
			@click=${clickNextYearHandler}
			class="calendar__arrow calendar__arrow--next-year"
		>
			<svg
				class="calendar__arrow__icon"
				viewBox="0 0 684 512"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path class="calendar__arrow__hover-element" d="M256.33,0a69.51,69.51,0,0,0-49.5,20.51l-186,186a70.07,70.07,0,0,0,0,99l186,186a70,70,0,0,0,99,0l35.32-35.32a70.08,70.08,0,0,0,0-99L240,256,341.16,154.84a70.08,70.08,0,0,0,0-99L305.84,20.51A69.55,69.55,0,0,0,256.33,0Z"/>
				<path class="calendar__arrow__hover-element" d="M578.86,0a69.55,69.55,0,0,0-49.51,20.51l-186,186a70.07,70.07,0,0,0,0,99l186,186a70,70,0,0,0,99,0l35.33-35.32a70.1,70.1,0,0,0,0-99L562.53,256,663.69,154.84a70.1,70.1,0,0,0,0-99L628.36,20.51A69.51,69.51,0,0,0,578.86,0Z"/>
				<path fill="currentColor" d="M256.33,38A31.9,31.9,0,0,1,279,47.37L314.3,82.7a32,32,0,0,1,0,45.27L208.91,233.36a32,32,0,0,0,0,45.28L314.3,384a32,32,0,0,1,0,45.27L279,464.63a32,32,0,0,1-45.27,0l-186-186a32,32,0,0,1,0-45.28l186-186A31.9,31.9,0,0,1,256.33,38m0-38a69.51,69.51,0,0,0-49.5,20.51l-186,186a70.07,70.07,0,0,0,0,99l186,186a70,70,0,0,0,99,0l35.32-35.32a70.08,70.08,0,0,0,0-99L240,256,341.16,154.84a70.08,70.08,0,0,0,0-99L305.84,20.51A69.55,69.55,0,0,0,256.33,0Z"/>
				<path fill="currentColor" d="M578.86,38a31.9,31.9,0,0,1,22.63,9.37L636.82,82.7a32,32,0,0,1,0,45.27L531.43,233.36a32,32,0,0,0,0,45.28L636.82,384a32,32,0,0,1,0,45.27l-35.33,35.33a32,32,0,0,1-45.27,0l-186-186a32,32,0,0,1,0-45.28l186-186A31.9,31.9,0,0,1,578.86,38m0-38a69.55,69.55,0,0,0-49.51,20.51l-186,186a70.07,70.07,0,0,0,0,99l186,186a70,70,0,0,0,99,0l35.33-35.32a70.1,70.1,0,0,0,0-99L562.53,256,663.69,154.84a70.1,70.1,0,0,0,0-99L628.36,20.51A69.51,69.51,0,0,0,578.86,0Z"/>
			</svg>
		</button>
	`;
}
